import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';

import { CrossSellPipe } from './cross-sell.pipe';
import { CrossSellBadgePipe } from './cross-sell-badge.pipe';
import { CrossSellAbreviacaoPipe } from './cross-sell-abreviacao.pipe';
import { CampanhaStatusIconPipe } from './cross-sell-icon.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CrossSellPipe,
        CrossSellBadgePipe,
        CrossSellAbreviacaoPipe,
        CampanhaStatusIconPipe
    ],
    exports: [
        CrossSellPipe,
        CrossSellBadgePipe,
        CrossSellAbreviacaoPipe,
        CampanhaStatusIconPipe
    ],
    providers: [
        CrossSellPipe,
        CrossSellBadgePipe,
        CrossSellAbreviacaoPipe,
        CampanhaStatusIconPipe
    ]
})
export class CrossSellPipeModule { }
